<template>
  <section class="main">
    <div v-show="isObjectLoading">
      <v-page-loading />
    </div>
    <div v-show="!isObjectLoading">
      <v-page-header :title="getPagetitle" />

      <div class="grid-container" v-if="object.user_type_id === 1">
        <div class="grid-x">
          <div class="cell small-auto medium-9 large-11">
            <div class="callout warning text-center">{{ $t('form.message.edit.adminaccount') }}</div>
          </div>
        </div>
      </div>
      <v-form-message
        id="form-error"
        :message="objectError"
        type="error"
        :isVisible="objectError !== null"
      />
      <v-form-message
        id="form-success"
        :message="objectSuccess"
        type="success"
        :isVisible="objectSuccess !== null"
        @onClickAction="onClickDialogAction"
      />

      <div class="grid-container">
        <div class="grid-x">
          <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
            <v-action-buttons
              :items="getActionButtons"
              :isDisabled="objectFormDisabled"
              @actionClicked="onClickAction"
            />

            <div class="loading-wrapper" :class="{'is-loading' : objectFormDisabled}">
              <form @submit="onSubmitObject">
                <div class="box">
                  <div class="form-block">
                    <div v-if="isViewMethod" class="form-group">
                      <label>{{ $t('form.account.salutation') }}</label>
                      <div class="form-control form-control--static">{{ object.profile.salutation }}</div>
                    </div>
                    <div v-else class="form-group">
                      <label for="form-field-salutation">{{ $t('form.account.title') }}</label>
                      <select
                        id="form-field-salutation"
                        name="salutation"
                        class="form-control form-control--select"
                        v-model="object.profile.salutation"
                      >
                        <option value>-</option>
                        <option v-for="(title, index) in $helpers.titles" :key="index">{{ title }}</option>
                      </select>
                    </div>
                    <div v-if="isViewMethod" class="form-group">
                      <label>{{ $t('form.account.firstname') }}</label>
                      <div class="form-control form-control--static">{{ object.profile.firstname }}</div>
                    </div>
                    <div
                      v-else
                      class="form-group"
                      :class="{ 'form-group--error' : $v.object.profile.firstname.$error, 'form-group--required' : $v.object.profile.firstname.$params.required }"
                    >
                      <label for="form-field-firstname">{{ $t('form.account.firstname') }}</label>
                      <input
                        type="text"
                        id="form-field-firstname"
                        name="firstname"
                        class="form-control"
                        :placeholder="$t('form.account.firstname.plc')"
                        v-model="$v.object.profile.firstname.$model"
                      />
                    </div>
                    <div v-if="isViewMethod" class="form-group">
                      <label>{{ $t('form.account.lastname') }}</label>
                      <div class="form-control form-control--static">{{ object.profile.lastname }}</div>
                    </div>
                    <div
                      v-else
                      class="form-group"
                      :class="{ 'form-group--error' : $v.object.profile.lastname.$error, 'form-group--required' : $v.object.profile.lastname.$params.required }"
                    >
                      <label for="form-field-lastname">{{ $t('form.account.lastname') }}</label>
                      <input
                        type="text"
                        id="form-field-lastname"
                        name="lastname"
                        class="form-control"
                        :placeholder="$t('form.account.lastname.plc')"
                        v-model="$v.object.profile.lastname.$model"
                      />
                    </div>
                    <div v-if="isViewMethod" class="form-group">
                      <label>{{ $t('form.account.gender') }}</label>
                      <div
                        class="form-control form-control--static"
                      >{{ $t('gender_' + object.profile.gender) }}</div>
                    </div>
                    <div v-else class="form-group">
                      <label for="form-field-gender">{{ $t('form.account.gender') }}</label>
                      <select
                        id="form-field-gender"
                        name="gender"
                        class="form-control form-control--select"
                        v-model="object.profile.gender"
                      >
                        <option value="2">{{ $t('gender_2') }}</option>
                        <option value="0">{{ $t('gender_0') }}</option>
                        <option value="1">{{ $t('gender_1') }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="box">
                  <div class="form-block">
                    <div v-if="isViewMethod" class="form-group">
                      <label>{{ $t('form.phone') }}</label>
                      <div
                        class="form-control form-control--static"
                      >{{ object.profile.communication.phone }}</div>
                    </div>
                    <div v-else class="form-group">
                      <label for="form-field-phone">{{ $t('form.phone') }}</label>
                      <input
                        type="tel"
                        id="form-field-phone"
                        name="phone"
                        class="form-control"
                        :placeholder="$t('form.phone.plc')"
                        v-model="object.profile.communication.phone"
                      />
                    </div>
                    <div v-if="isViewMethod" class="form-group">
                      <label>{{ $t('form.mobile') }}</label>
                      <div
                        class="form-control form-control--static"
                      >{{ object.profile.communication.mobile }}</div>
                    </div>
                    <div v-else class="form-group">
                      <label for="form-field-mobile">{{ $t('form.mobile') }}</label>
                      <input
                        type="tel"
                        id="form-field-mobile"
                        name="mobile"
                        class="form-control"
                        :placeholder="$t('form.mobile.plc')"
                        v-model="object.profile.communication.mobile"
                      />
                    </div>
                    <div v-if="isViewMethod" class="form-group form-group--required">
                      <label>{{ $t('form.email') }}</label>
                      <div
                        class="form-control form-control--static"
                      >{{ object.profile.communication.email }}</div>
                    </div>
                    <div
                      v-if="isCreateMethod"
                      class="form-group form-group--required"
                      :class="{ 'form-group--error' : $v.object.profile.communication.email.$error }"
                    >
                      <label for="form-field-email">{{ $t('form.email') }}</label>
                      <input
                        type="text"
                        id="form-field-email"
                        name="email"
                        class="form-control"
                        :placeholder="$t('form.account.email.plc')"
                        v-model="$v.object.profile.communication.email.$model"
                      />
                    </div>
                  </div>
                </div>

                <div class="box">
                  <div class="form-block">
                    <div class="grid-x grid-margin-x">
                      <div class="cell xxlarge-5 large-4">
                        <div v-if="isViewMethod" class="form-group">
                          <label>{{ $t('form.account.zipcode') }}</label>
                          <div
                            class="form-control form-control--static"
                          >{{ object.profile.address.zipcode }}</div>
                        </div>
                        <div v-else class="form-group">
                          <label for="form-field-zipcode">{{ $t('form.account.zipcode') }}</label>
                          <input
                            type="text"
                            id="form-field-zipcode"
                            name="phone"
                            class="form-control"
                            :placeholder="$t('form.account.zipcode.plc')"
                            v-model="object.profile.address.zipcode"
                          />
                        </div>
                      </div>
                      <div class="cell xxlarge-7 large-8">
                        <div v-if="isViewMethod" class="form-group">
                          <label>{{ $t('form.account.city') }}</label>
                          <div
                            class="form-control form-control--static"
                          >{{ object.profile.address.city }}</div>
                        </div>
                        <div v-else class="form-group">
                          <label for="form-field-city">{{ $t('form.account.city') }}</label>
                          <input
                            type="text"
                            id="form-field-city"
                            name="city"
                            class="form-control"
                            :placeholder="$t('form.account.city.plc')"
                            v-model="object.profile.address.city"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="grid-x grid-margin-x">
                      <div class="cell large-8">
                        <div v-if="isViewMethod" class="form-group">
                          <label>{{ $t('form.account.street') }}</label>
                          <div
                            class="form-control form-control--static"
                          >{{ object.profile.address.street }}</div>
                        </div>
                        <div v-else class="form-group">
                          <label for="form-field-street">{{ $t('form.account.street') }}</label>
                          <input
                            type="text"
                            id="form-field-street"
                            name="street"
                            class="form-control"
                            :placeholder="$t('form.account.street.plc')"
                            v-model="object.profile.address.street"
                          />
                        </div>
                      </div>
                      <div class="cell large-4">
                        <div v-if="isViewMethod" class="form-group">
                          <label>{{ $t('form.account.housenumber') }}</label>
                          <div
                            class="form-control form-control--static"
                          >{{ object.profile.address.housenumber }}</div>
                        </div>
                        <div v-else class="form-group">
                          <label for="form-field-housenumber">{{ $t('form.account.housenumber') }}</label>
                          <input
                            type="text"
                            id="form-field-housenumber"
                            name="housenumber"
                            class="form-control"
                            :placeholder="$t('form.account.housenumber.plc')"
                            v-model="object.profile.address.housenumber"
                          />
                        </div>
                      </div>
                    </div>
                    <div v-if="isViewMethod" class="form-group">
                      <label>{{ $t('form.account.region') }}</label>
                      <div
                        class="form-control form-control--static"
                      >{{ object.profile.address.region }}</div>
                    </div>
                    <div v-else class="form-group">
                      <label for="form-field-region">{{ $t('form.account.region') }}</label>
                      <input
                        type="text"
                        id="form-field-region"
                        name="region"
                        class="form-control"
                        :placeholder="$t('form.account.region.plc')"
                        v-model="object.profile.address.region"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PageHeader from "../partials/PageHeader";
import PageLoading from "../partials/PageLoading";
import ActionButtons from "./../partials/Foundation/ActionButtons";
import FormMessage from "./../partials/Forms/FormMessage";
import { required, email } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      objectLoading: false,
      objectError: null,
      objectSuccess: null,
      objectFormDisabled: false,
      object: {
        id: 0,
        active: 1,
        profile: {
          firstname: "",
          lastname: "",
          salutation: "",
          gender: "",
          links: [],
          address: {
            city: "",
            zipcode: "",
            street: "",
            region: "",
            housenumber: "",
            country_code: ""
          },
          communication: {
            email: "",
            mobile: "",
            phone: ""
          }
        },
        user_type_id: this.$helpers.usertypes.admin
      }
    };
  },
  components: {
    vPageHeader: PageHeader,
    vPageLoading: PageLoading,
    vActionButtons: ActionButtons,
    vFormMessage: FormMessage
  },
  computed: {
    isViewMethod: function() {
      return this.$route.meta.method === "view";
    },
    isCreateMethod: function() {
      return this.$route.meta.method === "create";
    },
    isUpdateMethod: function() {
      return this.$route.meta.method === "update";
    },
    isObjectLoading: function() {
      return this.objectLoading;
    },
    getActionButtons: function() {
      let buttons = [];

      if (this.isViewMethod) {
        buttons.push({
          action: "update",
          router: { name: "account-update-profile" }
        });
      }

      if (this.isCreateMethod || this.isUpdateMethod) {
        buttons.push("save", {
          action: "cancel",
          router: { name: "accounts" }
        });
      }

      return buttons;
    },
    getPagetitle: function() {
      let title;
      if (this.isViewMethod) {
        title = this.$t("account.view");
      }
      if (this.isCreateMethod) {
        title = this.$t("account.create");
      }
      if (this.isUpdateMethod) {
        title = this.$t("account.update");
      }
      return title;
    }
  },
  created: function() {
    if (this.isViewMethod || this.isUpdateMethod) {
      this.getObject();
    }
  },
  validations: function() {
    return {
      object: {
        profile: {
          firstname: {
            required
          },
          lastname: {
            required
          },
          communication: {
            email: {
              required,
              email
            }
          }
        }
      }
    };
  },
  methods: {
    onClickAction: function(action) {
      switch (action) {
        case "save":
          this.onSubmitObject();
          break;
      }
    },
    onClickDialogAction: function(id, action) {
      switch (action) {
        case "close":
          if (this.isCreateMethod) {
            this.$router.push({ name: "accounts" });
          }
          break;
      }
    },
    getObject: function() {
      let promise = this.$api
        .clearParams()
        .get("accounts/" + this.$route.params.account + "/get");

      promise
        .then(
          (response => {
            this.object = response.data.data;
          }).bind(this)
        )
        .catch(
          (error => {
            console.log(error);
          }).bind(this)
        )
        .finally(
          (() => {
            this.objectLoading = false;
          }).bind(this)
        );

      this.objectLoading = true;
    },
    onSubmitObject: function() {
      this.objectError = null;
      this.objectSuccess = null;
      this.objectFormDisabled = true;

      this.$v.object.$touch();

      if (this.$v.object.$invalid) {
        this.objectError = this.$t("form.error_form");
        this.objectFormDisabled = false;
      } else {
        let endpoint;
        let successMessage;
        if (this.object.id) {
          endpoint = "accounts/" + this.object.id + "/update";
          successMessage = this.$t("account.update.success");
        } else {
          endpoint = "accounts/create";
          successMessage = this.$t("account.create.success");
        }
        let promise = this.$api.clearParams().post(endpoint, this.object);

        promise
          .then(
            (() => {
              this.objectSuccess = successMessage;
            }).bind(this)
          )
          .catch(
            (error => {
              this.objectError = this.$t(error.response.data.message);
            }).bind(this)
          )
          .finally(
            (() => {
              this.objectFormDisabled = false;
            }).bind(this)
          );
      }
    }
  }
};
</script>